import React from 'react'

import { tokenVar } from '../../theme/tokenVar'

export type TrashIconProps = {
  size?: number
  color?: string
  colorScheme?: 'dark' | 'light'
  className?: string
}

export const TrashIcon = ({
  size = 20,
  color,
  colorScheme = 'dark',
  className,
}: TrashIconProps) => {
  const resolvedColor =
    color ??
    (colorScheme === 'light'
      ? tokenVar('colors.light.icon.secondary')
      : tokenVar('colors.icon.secondary'))
  return (
    <svg
      aria-label='Trash'
      className={className}
      fill='none'
      height={size}
      role='img'
      viewBox='0 0 24 24'
      width={size}
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M3 6h18'
        stroke={resolvedColor}
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth={1.5}
      />
      <path
        d='M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2'
        stroke={resolvedColor}
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth={1.5}
      />
      <path
        d='M10 11v6M14 11v6'
        stroke={resolvedColor}
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth={1.5}
      />
    </svg>
  )
}
